export default (function (value) {
  return value.match(/^\+?\d{9,17}$/);
});